// extracted by mini-css-extract-plugin
module.exports = {"footer-info":"jaYb8ir7WqTkdOLne3Qn7","body":"_2wXLdaqp1DqMvoy_3jiVG1","dialog":"HCvlqQ9QYQGBZ2OoHvV9t","table":"_33rK7XNUcWBIfTw72h3s2d"};